import type { CancellationMode, PPAccountIntegration } from '../types/paymentProcessor';

export function getKachingCancellationMode(account: PPAccountIntegration): CancellationMode {
  if (!account.kachingCancellationEnabled) return 'off';
  return account.kachingCancellationDryRun ? 'read_only' : 'cancel';
}

export function getKachingCancellationOnChargebackMode(account: PPAccountIntegration): CancellationMode {
  if (!account.kachingCancellationOnChargebackEnabled) return 'off';
  return account.kachingCancellationOnChargebackDryRun ? 'read_only' : 'cancel';
}
